// extracted by mini-css-extract-plugin
export default {"ideas":"ServicesIdeas_ideas__s9lGr"};